export const COOKIE_KEYS = {
  auth: {
    accessToken: 'access_token',
  },
  referral: {
    code: 'referral_code',
  },
  redirectTo: 'redirect-to',
  fundraiser: {
    access_token: 'f_access_token',
  },
}
